<script>
    import { format_dollars } from 'etap/filters/format_dollars';
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        mixins: [clickaway],
        filters: {
            format_dollars
        },
        data() {
            return {
                dashboardOpen: false,
                remainingBudget: null,
            }
        },
        props: {
            budgetLabel: {
                type: String,
                required: true
            }
        },
        created() {
            this.getRemainingBudgetCachedValue();
        },
        computed: {
            buttonColor() {
                if(this.dashboardOpen) {
                    return "nav-button-open";
                }

                return "nav-button";
            }
        },
        methods: {
            closeDashboard() {
                this.dashboardOpen = false;
            },
            getRemainingBudgetCachedValue() {
                this.$store.dispatch('incentive_dashboard/getCachedRemainingBudget').then(remaining_budget => {
                    if(remaining_budget !== null && remaining_budget !== '') {
                        this.remainingBudget = remaining_budget;
                    }
                });
            }
        }
    }
</script>
<template>
    <div v-if="remainingBudget !== null">
        <div class="incentive-dashboard p-4">
            <span class="remaining-budget-label" v-html="budgetLabel"></span><br>
            <span class="remaining-budget-amount text-bold text-md">{{ remainingBudget | format_dollars }}</span>
        </div>
        <div
            class="incentive-dashboard-icon"
            v-on-clickaway="closeDashboard"
        >
            <button
                class="text-white justify-center items-center header-icon box-shadow fa fa-usd"
                :class="buttonColor"
                @click="dashboardOpen = !dashboardOpen"
            ></button>
            <transition
                enter-active-class="animated faster fadeInDown"
                leave-active-class="animated faster fadeOut"
            >
                <div v-if="dashboardOpen" class="incentive-dashboard-card">
                    <span class="remaining-budget-label" v-html="budgetLabel"></span><br>
                    <span class="remaining-budget-amount text-bold text-md">{{ remainingBudget | format_dollars }}</span>
                </div>
            </transition>
        </div>
    </div>
</template>
